<mh-chain-followup-trends [showFilters]="showFilters" [productId]="2" [showAreas]="false"></mh-chain-followup-trends>